import { render, staticRenderFns } from "./LogotypeBand.vue?vue&type=template&id=953e0232"
import script from "./LogotypeBand.vue?vue&type=script&lang=js"
export * from "./LogotypeBand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports